import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useConfiguration from "../../hooks/useConfiguration";
import DropDown from "../common/SearchableSelect";
import MultiSelect from "../common/TextField/dropDown";
import {
    updateLocation, updateLocationApprovers,
    updateLocationContactPersons, updateLocationDropdownsInMasterData
} from "./action";
import { jobOpportunitySelector } from "./selector";
import { setGrouping, setJobEncounterOccurreneUpdateList, setSelectedAuthUsers, setShowCalenderModal, setencounterCalculation, setjobMultishiftOccurreneUpdateList } from "./slice";

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
    const { masterData, location, displayContactApprovererror ,selectedAuthUsers,grouping} = useSelector(jobOpportunitySelector);
    //console.log(masterData?.allJobLocations);

    const apporverselectRef = useRef();
    const contactpersonelectRef = useRef();
    const dispatch = useDispatch();
    const config = useConfiguration();

    const updateJobLocation = (target) => {
        if (target.name === 'locationNameInfo') {
            apporverselectRef?.current?.resetSelectedValues();
            contactpersonelectRef?.current?.resetSelectedValues();
            dispatch(updateLocationDropdownsInMasterData(`${config.baseUrl}`, target.value.id));
        };
        dispatch(setShowCalenderModal(false))
        dispatch(setjobMultishiftOccurreneUpdateList([]))
        if(selectedAuthUsers || grouping){
            dispatch(setSelectedAuthUsers([]))
            dispatch(setGrouping({ key: "group", value: [] }));
            dispatch(setGrouping({ key: "resources", value: [] }));
            dispatch(setencounterCalculation([]))
            dispatch(setSelectedAuthUsers([]))
            dispatch(
              setJobEncounterOccurreneUpdateList(JSON.parse(JSON.stringify([])))
            );
              }
        dispatch(updateLocation(target.name, target.value));
    }
    const updateContactPersons = (target) => {
        const value = target.value;
        const action = target.action || 'add';
        dispatch(setShowCalenderModal(false))
        dispatch(setjobMultishiftOccurreneUpdateList([]))
        dispatch(updateLocationContactPersons(value, action));
    };


    const updateApprovers = (target) => {
        const value = target.value;
        const action = target.action || 'add';
        dispatch(setShowCalenderModal(false))
        dispatch(setjobMultishiftOccurreneUpdateList([]))
        dispatch(updateLocationApprovers(value, action));
    };


    return (
        <div className="card">
            <div>
                <div className="row">
                    <div className="card-header">
                        <div className="col-lg-4 col-md-4">
                            <h3 class="card-title">Location Info  <span class="required">*</span></h3>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <DropDown name={'locationNameInfo'}
                                divClass="col-lg-4 col-md-4"
                                label={'Location Name'}
                                star={'*'}
                                placeholder={"Select"}
                                id={'locationNameInfo'}
                                options={masterData?.allJobLocations} multiple={false}
                                value={location.locationNameInfo ? [location.locationNameInfo] : []}
                                updateValue={updateJobLocation} isObject={true}
                                errors={props.errors ? props.errors['locationNameInfo'] : []}
                            />
                            <MultiSelect name={'contactPersons'}
                                divClass="col-lg-4 col-md-4"
                                label={'Contact persons'}
                                star={'*'}
                                id={'contactPersons'}
                                value={location?.contactPersons}
                                options={masterData?.allJobLocationContactPersons} multiple={true}
                                updateValue={updateContactPersons} isObject={true}
                                selectionLimit={masterData?.maxContactPersons}
                                errors={props.errors ? props.errors['contactPersons'] : []}
                                multiselectRef={contactpersonelectRef}
                            />

                            <MultiSelect name={'approvalUsers'}
                                divClass="col-lg-4 col-md-4"
                                label={'Approval users'}
                                star={'*'}
                                id={'approvalUsers'}
                                value={location?.approvalUsers}
                                options={masterData?.allJobLocationApprovers} multiple={true}
                                updateValue={updateApprovers} isObject={true}
                                selectionLimit={masterData?.maxApprovalUsers}
                                errors={props.errors ? props.errors['approvalUsers'] : []}
                                multiselectRef={apporverselectRef}
                            />

                        </div>
                        <div className="row">
                            {
                                displayContactApprovererror &&
                                <>
                                    <div className="col-lg-4 col-md-4 invalid-input"><span></span></div>
                                    <div className="col-lg-4 col-md-4 invalid-input"><span>{masterData?.allJobLocationContactPersons?.length === 0 && 'Contact persons are not available'}</span></div>
                                    <div className="col-lg-4 col-md-4 invalid-input"><span>{masterData?.allJobLocationApprovers?.length === 0 && 'Approval users are not available'}</span></div>
                                </>
                            }
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}
